<fcom-modal
  [(open)]="isOpen"
  [title]="'MMB.thirdparty.expedia.legalModal.title' | finLocalization"
  [buttons]="ModalButtons.CUSTOM"
>
  <div class="pr-large">
    <cms-unstyled-fragment
      [contentUrl$]="'MMB.fragments.expediaHotelsLegislationModal.url' | finLocalization | finToObservable"
    ></cms-unstyled-fragment>

    <fcom-link
      class="mr-medium-y block"
      (beforeNavigation)="expandClick()"
      [id]="id"
      data-testid="expedia-legalmodal-expand-content"
    >
      <span>
        {{ 'MMB.thirdparty.expedia.legalModal.expandTitle' | finLocalization }}
      </span>
      <fcom-icon
        [name]="SvgLibraryIcon.CHEVRON_DOWN"
        class="rotate ms-xxsmall-l"
        [class.rotate-active]="expandOpen()"
      ></fcom-icon>
    </fcom-link>

    <fcom-expand [open]="expandOpen()" [ariaLabelledBy]="id">
      <cms-unstyled-fragment
        class="mr-medium-b block"
        [contentUrl$]="'MMB.fragments.expediaHotelsLegislationModalExpanded.url' | finLocalization | finToObservable"
      ></cms-unstyled-fragment>
    </fcom-expand>

    <div class="flex">
      <div class="ps-xxsmall-r font-body-1">
        {{ 'MMB.thirdparty.expedia.legalModal.poweredBy' | finLocalization }}
      </div>
      <fcom-icon class="provider-logo" [category]="IconLibrary.CUSTOM" [name]="CustomIcon.HOTELS_LOGO"></fcom-icon>
    </div>
  </div>

  <div buttons class="button-container">
    <fcom-button
      [text]="'actions.cancel' | finLocalization"
      [theme]="ButtonTheme.LIGHT_SECONDARY_OUTLINE"
      [mode]="ButtonMode.FILL_MOBILE"
      (clickBtn)="isOpen.set(false)"
      class="ms-xxsmall-x"
      data-testid="expedia-legalmodal-cancel-button"
    ></fcom-button>
    <fcom-button
      [text]="'actions.continue' | finLocalization"
      [theme]="ButtonTheme.LIGHT_PRIMARY_NORDIC_BLUE"
      [href]="redirectUrl"
      [openInNewTab]="true"
      [externalLink]="true"
      [mode]="ButtonMode.FILL_MOBILE"
      (clickBtn)="isOpen.set(false)"
      class="ms-xxsmall-x expedia-continue-button"
      data-testid="expedia-legalmodal-continue-button"
      [icon]="{
        position: IconPosition.RIGHT,
        category: IconLibrary.SVG_LIBRARY,
        name: SvgLibraryIcon.EXTERNAL_TAB,
      }"
    ></fcom-button>
  </div>
</fcom-modal>
